/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Withdrawal_SentInputs */

const en_withdrawal_sent = /** @type {(inputs: Withdrawal_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Withdrawal sent. Confirmation is on its way to ${i?.email}.`)
};

const pl_withdrawal_sent = /** @type {(inputs: Withdrawal_SentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wysłano odstąpienie od umowy. Potwierdzenie idzie na ${i?.email}.`)
};

/**
* | output |
* | --- |
* | "Withdrawal sent. Confirmation is on its way to {email}." |
*
* @param {Withdrawal_SentInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const withdrawal_sent = /** @type {((inputs: Withdrawal_SentInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Withdrawal_SentInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_withdrawal_sent(inputs)
	return en_withdrawal_sent(inputs)
});